import { Question } from "../../Api"

// SORTING //
export   const sortQuestions = (questions: Question[]) => {
    let sorted = questions.sort((a, b) => (a.groupSort ? a.groupSort : 0) - (b.groupSort ? b.groupSort : 0))
    return sorted
  }

export   const sortAnswerChoices = (question: Question) => {
    let answers = question.answerChoices
    let sorted = answers.sort((a, b) => (a.sort ? a.sort : 0) - (b.sort ? b.sort : 0))
    return sorted
  }


  // QUESTON LOGIC //
  /**
 *
 * Check if question is still active
 */
  export const isQuestionActive = (stop: number) => {
    let now = new Date()
    let currentTime = now.getTime() / 1000
    if(stop < currentTime){
        //Question is locked
        return false
    }
    return true
}

/**
 *
 * Check if user can change their answer
 */
export const isQuestionChangable = (question: Question) => {
    if(!question.userAnswerCode) return true // Has not answered yet
    if(isQuestionActive(question.closeTime) && question.isChangeable){
        return true
    }
    return false
}

export const shouldShowPercent = (question: Question) => {
    // Percent should always be shown
    if(question.showPctBefore) return true

    //Show only after answering
    if(question.userAnswerCode
        && question.showAfterSubmit){
        return true
    }

    //Show only when answer is closed
    if(!isQuestionActive(question.closeTime) && question.showPctAfter){
        return true
    }
    
    return false
}